import { Col, Row } from "antd";
import cuid from "cuid";
import { Formik } from "formik";
import { defaultsDeep } from "lodash";
import { useTranslation } from "react-i18next";
import Card from "shared/components/Card";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { PROCESS_CONFIG_TYPES } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";

const AdditionalConfiguration = ({
  formRef,
  dirtyRef,
  setIsDirty,
  TABS,
  data,
  onSubmit,
  config,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const FORM = t("FORM", { returnObjects: true });

  const existingProductConfig = config.find(
    ({ type }) => type === PROCESS_CONFIG_TYPES.PRODUCT,
  );

  const initialProductValue = existingProductConfig?.value || "";

  return (
    <Formik
      innerRef={(formik) => {
        formRef.current = formik;
      }}
      enableReinitialize={true}
      initialValues={{
        produit: initialProductValue,
      }}
      onSubmit={async (values) => {
        const productConfig = {
          id: existingProductConfig?.id || cuid(),
          type: PROCESS_CONFIG_TYPES.PRODUCT,
          value: values.produit || "",
        };

        await onSubmit({
          type: data.type,
          name: data.name,
          theme: data.theme,
          description: data.description,
          skills: data.skills,
          config: [
            ...config.filter(
              ({ type }) => type !== PROCESS_CONFIG_TYPES.PRODUCT,
            ),
            productConfig,
          ],
          attributionType: defaultsDeep(
            config.find(
              ({ type }) => type === PROCESS_CONFIG_TYPES.ATTRIBUTION_TYPE,
            ),
            {
              id: cuid(),
              type: PROCESS_CONFIG_TYPES.ATTRIBUTION_TYPE,
              value: null,
            },
          ),
          processStatuses: data.processStatuses,
          insurancePlans: data.insurancePlans?.map(({ id }) => id),
        });
        setIsDirty((prev) => ({ ...prev, [TABS.ADDITIONAL_CONFIG]: false }));
      }}
    >
      {({ values, dirty, ...formProps }) => {
        if (dirtyRef.current !== dirty) {
          dirtyRef.current = dirty;
          setIsDirty((prev) => ({ ...prev, [TABS.ADDITIONAL_CONFIG]: dirty }));
        }

        return (
          <Card
            type="simple"
            head={false}
            title={FORM.ADDITIONAL_CONFIG || "Configuration Additionnel"}
          >
            <div className="grid--3">
              <Input
                type="simple"
                placeholder={FORM.PRODUCT || "Produit"}
                label={FORM.PRODUCT || "Produit"}
                {...bindInputProps({
                  name: "produit",
                  values,
                  ...formProps,
                })}
              />
            </div>
          </Card>
        );
      }}
    </Formik>
  );
};

export default AdditionalConfiguration;
